import Company from './Company';
import { authRoles } from 'auth/auth';
import LoadUserData from '../../LoadUserData';

export const CompanyConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: authRoles.admin,//['admin','staff']
  routes: [
    {
      path: '/dashboard',
      component: LoadUserData(Company)
    }
  ]
};



// WEBPACK FOOTER //
// ./src/main/content/company/CompanyConfig.js